import { tns } from "tiny-slider"

window.onload = () => {
    const sliderElm = [].slice.call(document.querySelectorAll(".js-tns-slider"))

    if (sliderElm.length > 0) {
        sliderElm.map(function (node) {
            let items = node.dataset.items || 1
            let autoplay = node.dataset.autoplay || false
            let loop = node.dataset.autoplay || false
            let gutter = node.dataset.gutter || 0
            let speed = node.dataset.speed || 300
            let nav = node.dataset.nav || false
            let edgePadding = node.dataset.edgePadding || 0
            let navPosition = node.dataset.navPosition || "button"

            tns({
                container: node,
                loop: loop,
                items: items,
                gutter: gutter,
                nav: nav,
                autoplay: autoplay,
                speed: speed,
                controls: false,
                navPosition: navPosition,
                edgePadding: edgePadding,
                mouseDrag: true,
            })
        })
    }
}
